export default function IconNavArrowLeft({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.52 0.52 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7.26319 9.80135C7.14672 9.70237 7.05316 9.57925 6.989 9.44052C6.92483 9.30179 6.8916 9.15077 6.8916 8.99792C6.8916 8.84507 6.92483 8.69405 6.989 8.55532C7.05316 8.41659 7.14672 8.29347 7.26319 8.19448L15.171 1.33824C15.3244 1.20776 15.5119 1.12393 15.7114 1.09664C15.9108 1.06936 16.114 1.09976 16.2967 1.18427C16.4795 1.26877 16.6342 1.40384 16.7427 1.5735C16.8511 1.74316 16.9087 1.94032 16.9086 2.14167V15.8485C16.9087 16.0499 16.8511 16.2471 16.7427 16.4167C16.6342 16.5864 16.4795 16.7214 16.2967 16.8059C16.114 16.8905 15.9108 16.9209 15.7114 16.8936C15.5119 16.8663 15.3244 16.7825 15.171 16.652L7.26319 9.80135Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1091 15.3267V15.8538C11.1092 16.0552 11.0516 16.2524 10.9431 16.422C10.8347 16.5917 10.68 16.7267 10.4972 16.8112C10.3145 16.8958 10.1113 16.9262 9.91183 16.8989C9.71233 16.8716 9.52482 16.7878 9.37147 16.6573L1.46436 9.80173C1.34789 9.70275 1.25433 9.57963 1.19017 9.4409C1.12601 9.30217 1.09277 9.15115 1.09277 8.9983C1.09277 8.84545 1.12601 8.69443 1.19017 8.5557C1.25433 8.41697 1.34789 8.29385 1.46436 8.19487L9.37217 1.33862C9.52573 1.2082 9.71343 1.12451 9.91306 1.09745C10.1127 1.07038 10.3159 1.10108 10.4986 1.1859C10.6814 1.27072 10.836 1.40612 10.9442 1.57607C11.0523 1.74602 11.1096 1.9434 11.1091 2.14486V2.67416"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
